import React from 'react';
export const ChatDescription = ({ text }) => {
    if (!text) {
        return null;
    }
    return (React.createElement("div", { className: "box-border flex w-full border-b border-solid border-gray-1 px-8 py-4 text-reading-lg" }, text));
};
